import React from "react";

import { styled } from "@mui/material/styles";

interface SytledStorageBoxBadgeProps {
  backgroundColor: string;
  textColor: string;
}

interface StyledStorageBoxBadgeProps {
  backgroundColor: string;
  textColor: string;
}

export const SytledStorageBoxBadge = styled("div", {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "textColor",
})<StyledStorageBoxBadgeProps>(({ backgroundColor, textColor }) => ({
  display: "inline-block",
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: "10px",
  lineHeight: "20px",
  background: `${backgroundColor} !important`,
  color: `${textColor} !important`,
  padding: "6px 10px",
  borderRadius: "20px",
  mixBlendMode: "multiply",
}));
type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  className?: string;
};

export enum StorageStatuses {
  LOADED = "loaded",
  EMPTY = "empty",
  IN_TRANSIT = "in transit",
  PACKED = "packed",
  INACTIVE = "inactive",
  UNUSABLE = "unusable",
  FULL = "full",
}

const BadgeStorageBoxStatus = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <SytledStorageBoxBadge
          data-cy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          className={className}
        >
          {value}
        </SytledStorageBoxBadge>
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case StorageStatuses.IN_TRANSIT:
      return renderBadge("#FCE7F6", "#DD2590", value);
    case StorageStatuses.UNUSABLE:
      return renderBadge("#E0EAFF", "#444CE7", value);
    case StorageStatuses.INACTIVE:
      return renderBadge("#FEF3F2", "#D92D20", value);
    case StorageStatuses.LOADED:
      return renderBadge("#FEF0C7", "#DC6803", value);
    case StorageStatuses.EMPTY:
      return renderBadge("#F2F4F7", "#475467", value);
    case StorageStatuses.FULL:
      return renderBadge("#D1FADF", "#12B76A", value);
    default:
      return renderBadge("#F2F4F7", "#475467", value);
  }
};

export default BadgeStorageBoxStatus;
